import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';

export const ArchiveUploadForm = ({ upload, setFiles, onClose }) => {
    const { token, base_url } = useAppContext();

    return (
        <ConfirmDialog
            open
            onOpenChange={(next) => {
                if (!next) onClose();
            }}
            title="Archive Upload"
            message="Archive this file? It will be removed from this project's uploads list."
            entityLabel={`File: ${upload?.upload_name}`}
            confirmLabel="Archive"
            submittingLabel="Archiving..."
            successMessage="Upload archived successfully!"
            errorMessages={{
                notFound: 'Upload not found',
                client: 'Invalid upload data. Please check your input.',
                default: 'Failed to archive upload. Please try again.',
            }}
            onConfirm={async () => {
                const response = await updateData(
                    token,
                    `${base_url}/apis/uploads/${upload.id}`,
                    { is_archived: true }
                );

                if (!response?.upload) {
                    if (window.showAlert) {
                        window.showAlert(
                            500,
                            'Failed to archive upload: ' + (response?.msg || 'Unknown error')
                        );
                    }
                    return false;
                }

                setFiles((prev) => prev.filter((f) => f.id !== upload.id));
            }}
        />
    );
};
